import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { Button, MenuItem } from '@material-ui/core';

import { ReactComponent as CardsIcon } from '../../assets/icons/ic_card.svg';
import { ReactComponent as PersonIcon } from '../../assets/icons/ic_person.svg';
import { ReactComponent as SignOutIcon } from '../../assets/icons/ic_signout.svg';
import UserIcon from '../../assets/icons/ubr_profile.svg';
import UnicredLogo from '../../assets/logos/logo_uni_horizontal_verde.svg';
import DelayLink from '../../components/DelayLink';
import { useAuth } from '../../hooks/useAuth';
import useRedirect from '../../hooks/useRedirect';
import {
  HeaderPage,
  Container,
  UserContainer,
  MenuMobile,
  UserContainerMobile,
  Hamburger,
  Backdrop,
} from './styles';
import { RoutesPaths } from '../../routes';

import { Img } from '..';

interface HeaderProps {
  protect?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ protect }) => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const { user, signOut } = useAuth();
  const redirect = useRedirect();

  const toggle = () => {
    setIsActive(!isActive);
  };

  return (
    <HeaderPage id={'headerPage'}>
      <Container>
        <figure>
          {user ? (
            <Link to={RoutesPaths.home}>
              <Img src={UnicredLogo} alt="Logo Unicred" />
            </Link>
          ) : (
            <Link to="#">
              <Img src={UnicredLogo} alt="Logo Unicred" />
            </Link>
          )}
        </figure>
        <Button
          className={isActive ? 'active' : ''}
          onClick={toggle}
          disabled={protect}
        >
          <UserContainer>
            <Img src={UserIcon} alt="Imagem do usuário" />
            {user ? (
              <>
                {user.agencia === null && user.conta === null ? (
                  <span>{user.nome}</span>
                ) : (
                  <span>
                    Agência: <b>{user.agencia}</b>, Conta: <b>{user.conta}</b>
                  </span>
                )}
              </>
            ) : (
              <span>Sem identificação</span>
            )}
          </UserContainer>
          <Hamburger className="menu-open-button" htmlFor="menu-open">
            <span
              className={isActive ? 'hamburger-1 active' : 'hamburger-1'}
            ></span>
            <span
              className={isActive ? 'hamburger-2 active' : 'hamburger-2'}
            ></span>
            <span
              className={isActive ? 'hamburger-3 active' : 'hamburger-3'}
            ></span>
          </Hamburger>
        </Button>

        {!protect && (
          <>
            <MenuMobile className={isActive ? 'active' : ''}>
              <UserContainerMobile>
                <Img src={UserIcon} alt="Imagem do usuário" />
                {user ? (
                  <>
                    {user.agencia === null && user.conta === null ? (
                      <span>Usuário {user.roles}</span>
                    ) : (
                      <span>
                        Agência: <b>{user.agencia}</b>, Conta:{' '}
                        <b>{user.conta}</b>
                      </span>
                    )}
                  </>
                ) : (
                  <span>Sem identificação</span>
                )}
              </UserContainerMobile>

              {user && (
                <>
                  {user.roles[0] === 'interno' && (
                    <>
                      <MenuItem
                        onClick={() =>
                          setTimeout(() => {
                            setIsActive(false);
                          }, 500)
                        }
                      >
                        <div>
                          <DelayLink
                            to={user ? `${RoutesPaths.listScreen}` : '#'}
                          >
                            <CardsIcon />
                            Telas
                          </DelayLink>
                        </div>
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          setTimeout(() => {
                            setIsActive(false);
                          }, 500)
                        }
                      >
                        <div>
                          <DelayLink
                            to={user ? `${RoutesPaths.listPerfil}` : '#'}
                          >
                            <PersonIcon />
                            Perfis
                          </DelayLink>
                        </div>
                      </MenuItem>
                    </>
                  )}
                </>
              )}

              <MenuItem
                onClick={() =>
                  setTimeout(() => {
                    redirect(`${RoutesPaths.login}`);
                    setIsActive(false);
                    signOut();
                  }, 500)
                }
              >
                <div>
                  <DelayLink to={'#'}>
                    <SignOutIcon />
                    Logout
                  </DelayLink>
                </div>
              </MenuItem>
            </MenuMobile>
            <Backdrop onClick={toggle} className={isActive ? 'active' : ''} />
          </>
        )}
      </Container>
    </HeaderPage>
  );
};
